import React from "react";
import { cn } from "@/lib/utils";

interface CouponRevealButtonProps
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "children"> {
  couponCode: string;
  mobile?: boolean;
}

export default function CouponRevealButton({
  couponCode,
  className,
  mobile = false,
  ...props
}: CouponRevealButtonProps) {
  return (
    <button
      type="button"
      className={cn(
        "coupon-reveal-button focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-600 focus-visible:ring-offset-2",
        mobile && "coupon-reveal-button--mobile",
        className,
      )}
      {...props}
    >
      <span className="coupon-reveal-button__code border-purple-600" aria-hidden="true">
        {couponCode}
      </span>
      <span className="coupon-reveal-button__front bg-purple-600 text-white">Show Code</span>
    </button>
  );
}
